import { Rule } from 'antd/es/form';

const digitsRegEx = /^[0-9]+$/;

export const commonFieldRules = {
  fieldIsRequired: (errorMessage: string): Rule => ({
    required: true,
    message: errorMessage,
  }),
  fieldIsEmail: (errorMessage: string): Rule => ({
    type: 'email',
    message: errorMessage,
  }),
};

export const inputFieldRules = {
  fieldInputTooLong: (errorMessage: string, maxLength: number): Rule => ({
    max: maxLength,
    message: errorMessage,
  }),
};

export const numberFieldRules = {
  digitsOnly: (errorMessage: string): Rule => ({
    validator: (_, value) => {
      if (!value) {
        return Promise.resolve();
      }
      if (value && digitsRegEx.test(value)) {
        return Promise.resolve();
      }
      return Promise.reject(new Error(errorMessage));
    },
  }),
};

export const checkboxFieldRules = {
  requireChecked: (errorMessage: string): Rule => ({
    validator: (_, value) => {
      if (value === true) {
        return Promise.resolve();
      }
      return Promise.reject(new Error(errorMessage));
    },
  }),
};
